<template>
  <div class="homePage">
    <div class="title">小 鳗 管 家</div>
    <div class="engTitle">SM<span style="color:#3170FF">A</span>LLEEL PL<span style="color:#3170FF">A</span>TFORM</div>
    <div class="image">
      <img  src="@/assets/Modle.png"/>
    </div>
     <el-button type="primary" style="width:130px;height:40px;background:#316FFD;border:none;margin-top:30px;font-size:16px" @click="showMore">了解更多</el-button>
     <div><img  src="@/assets/home_line.png" style="height:3px;padding-top:10px"></div>
     <div class="textArea">
       <span style="color:#3170FF">小鳗管家</span>能源管理系统利用物联网技术、移动互联网、大数据等技术，打通智能计量监测设备、数据采集器、云主机三者间的数据收发通道，形成高效的能耗物联网生态。满足商业建筑在配电监控、用电安全、能耗监测、新能源监控、碳排放监测等方面的需求，为客户搭建一套数字化的能源管控平台，实现绿色节能和高效运行管理。
     </div>
  </div>
</template>

<script>
export default {
  data(){
    return{

    }
  },
  methods:{
    showMore(){
      this.$router.push({path:'/phoneUserVal'})
    }
  },
  mounted() {
  },
}
</script>

<style scoped lang="scss">
.homePage{
  color: white;
  background-image:url( '../../../assets/homeBg.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  height: 100vh;
}
.title{
  font-size: 40px;
  font-family: 'PangMenZhengDao';
  text-align: center;
  padding-top: 8vh;
  font-weight: 400;
  text-align: center;
}
.engTitle{
  font-size: 12px;
  font-family: PangMenZhengDao;
  font-weight: 400;
  color: #FFFFFF;
  padding-top: 1.2%;
}
.image{
  padding: 0 28px;
  padding-top: 8vh;
  img{
    width: 319px;
    height: 254px;
  }
}
.textArea{
  background-color: #292B2F;
  margin: 20px;
  padding: 10px;
  font-family: SourceHanSansCN-Regular;
  font-size: 12px;
  text-indent: 0.5cm;
  letter-spacing:3px;
  text-align: left;
  line-height:18px
}
</style>



// WEBPACK FOOTER //
// src/components/page/phone/phoneHome.vue